module.exports = __webpack_public_path__ + "static/media/mpl-logo.f3bd3ae6.png";